var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "breeding-rhombus-spinner", style: _vm.spinnerStyle },
    [
      _vm._l(_vm.rhombusesStyles, function(rs, index) {
        return _c("div", {
          key: index,
          staticClass: "rhombus",
          class: `child-${index + 1}`,
          style: rs
        })
      }),
      _vm._v(" "),
      _c("div", { staticClass: "rhombus big", style: _vm.bigRhombusStyle })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }